import React from "react";
import { Form, Select } from "antd";
import Icons from "components/icons";
import Localize, { localizeByKey } from "components/service/localize";

type TExhibitionTypeSelectProps = {
    disabled?: boolean;
    rules?: boolean | { required: true; message: string }[];
    initialValue?: string;
    mode?: string;
    name?: string;
    label?: string;
};

const ExhibitionTypeSelect: React.FC<TExhibitionTypeSelectProps> = ({
    disabled = false,
    rules = true,
    initialValue,
    mode = "",
    name = "exhibition_type",
    label = "FORMS.Input_Label_ExhibitionType",
}) =>
{
    return (
        <Form.Item
            name={name}
            label={localizeByKey(label)}
            initialValue={initialValue}
            rules={
                rules && rules !== true
                    ? rules
                    : [
                        {
                            required: true,
                            message: (
                                <Localize>
                                    FORM_RULES.Required_ExhibitionTypes
                                </Localize>
                            ),
                        },
                    ]
            }
        >
            <Select
                showSearch
                suffixIcon={<Icons.Arrow />}
                mode={mode as any}
                disabled={disabled}
                placeholder={localizeByKey(label).toString()}
                popupClassName="select-serch-dropdown"
                optionFilterProp="value"
            >
                <Select.Option key="all_in" value="all_in">
                    All IN
                </Select.Option>
                <Select.Option key="aaa" value="aaa">
                    AAA
                </Select.Option>
                <Select.Option key="fmb" value="fmb">
                    FMB
                </Select.Option>
            </Select>
        </Form.Item>
    );
};

export default ExhibitionTypeSelect;
